import React from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'

const Notification = ({ message, className }) => (
  <div className={`notification ${className}`}>{ReactHtmlParser(message)}</div>
)

Notification.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default Notification
